import React from "react";
import { AppShell, Burger, Group, Image } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import MobileNavigationBar from "../navigation-bar/MobileNavigationBar";

function MobileLayout() {
  const [opened, { toggle }] = useDisclosure();

  return (
    <AppShell
      header={{ height: 100 }}
      navbar={{
        width: "100%",
        breakpoint: "sm",
        collapsed: { mobile: !opened, desktop: !opened },
      }}
      padding="md"
    >
      <AppShell.Header
        style={{ backgroundColor: opened ? "#FFF" : "#2B71B9", border: "none" }}
      >
        <Group h="100%" px="md" justify="space-between">
          {opened ? (
            <Image src={"/images/colored-logo.png"} h={80} w={100} />
          ) : (
            <Image src={"/images/white-logo.png"} h={80} w={100} />
          )}
          <Burger
            opened={opened}
            onClick={toggle}
            size="lg"
            color={opened ? "#E01C1C" : "#FFF"}
          />
        </Group>
      </AppShell.Header>
      <AppShell.Navbar p={0}>
        <MobileNavigationBar toggle={toggle} />
      </AppShell.Navbar>
      {/* <AppShell.Main>{Children}</AppShell.Main> */}
    </AppShell>
  );
}

export default MobileLayout;
